import { Resources } from 'constants/resources';

import { useGetList } from 'react-admin';
import { AlertProps } from 'shared/mui/Alert/Alert';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Currency } from 'types/embedded/currency';
import { getReportPeriod } from 'utils/getReportPeriod';

import { AlertStyled } from './SuccessReportAlert.styled';

type Props = {
  onClose: VoidFunction;
  date?: {
    gte?: number | null;
    lte?: number | null;
  };
  timezone?: string;
  currency: string;
  conversionRateType?: string;
} & AlertProps;

export const SuccessReportConvertedAlert: React.FC<Props> = ({
  onClose,
  date,
  timezone,
  currency,
  conversionRateType,
}) => {
  const { data: currencyData } = useGetList<Currency>(Resources.Currencies, {
    filter: { alphaCode: currency },
    sort: { field: 'id', order: 'ASC' },
  });
  const currencyName = currency
    ? `${currencyData?.[0]?.alphaCode}, ${currencyData?.[0]?.name}`
    : '';

  return (
    <AlertStyled
      action={<CloseIconButton onClose={onClose} sx={{ color: 'text.secondary' }} />}
      severity="success"
    >
      Отчёт сформирован за период{' '}
      {getReportPeriod({ dateGte: date?.gte, dateLte: date?.lte, timezone })} и сконвертирован в
      валюте {currencyName} на {conversionRateType === 'actual' ? 'текущую' : 'конечную'} дату
      запроса.
    </AlertStyled>
  );
};
